import { logger } from "../util/Logger";
import { MultipleCommands } from "./MultipleCommand";

export enum CommandMode {
  PENDING,
  IMMEDIATE,
}

export interface Command {
  ref(): object | undefined | void;
  do(): void;
  undo(): void;
  release(): void;
  action(): void;
}

export class CommandManager {
  private commands: Command[] = [];
  private _commandIndex: number = -1;

  private _pendingCommands: Command[] = [];

  private _active = true;
  set active(b: boolean) {
    this._active = b;
  }

  private _mode = CommandMode.IMMEDIATE;
  set mode(b: CommandMode) {
    this._mode = b;
  }

  run(command: Command) {
    this.addCommand(command);
    return command.ref();
  }

  private _addPendingCommand(command: Command | Command[], index?: number) {
    if (index == undefined || index == null)
      index = this._pendingCommands.length;

    if (command instanceof Array) {
      this._pendingCommands.splice(index, 0, ...command);
    } else {
      this._pendingCommands.splice(index, 0, command);
    }
  }

  addCommand(command: Command | Command[]) {
    if (!this._active) return;

    if (this._mode == CommandMode.PENDING) {
      this._addPendingCommand(command);
      return;
    }

    this._addCommand(command);
  }

  private _addCommand(command: Command | Command[]) {
    const newCommands = command instanceof Array ? command : [command];

    for (let i = this._commandIndex + 1; i < this.commands.length; i++) {
      this.commands[i].release();
    }

    if (this._commandIndex < this.commands.length - 1) {
      this.commands.splice(this._commandIndex + 1);
    }

    this.commands.push(...newCommands);
    this._commandIndex = this.commands.length - 1;
  }

  do() {
    if (this._commandIndex < this.commands.length - 1) {
      this._commandIndex++;
      logger.info("commands to redo", this.commands[this._commandIndex]);
      this.commands[this._commandIndex].do();
      this.commands[this._commandIndex].action();
    } else {
      logger.info("No commands to do.");
    }
  }

  undo() {
    if (this._commandIndex >= 0) {
      logger.info("commands to undo", this.commands[this._commandIndex]);
      this.commands[this._commandIndex].undo();
      this.commands[this._commandIndex].action();
      this._commandIndex--;
    } else {
      logger.info("No commands to undo.");
    }
  }

  canRedo(): boolean {
    return this._commandIndex < this.commands.length - 1;
  }

  canUndo(): boolean {
    return this._commandIndex >= 0;
  }

  commit(ev: () => void) {
    if (this._pendingCommands.length < 1) return;
    const pendinCommand = new MultipleCommands(this._pendingCommands);
    pendinCommand.action = ev;
    this._pendingCommands = [];
    this._addCommand(pendinCommand);
  }
}

export const globalCommandManager = new CommandManager();
(window as any)["GlobalCommandManager"] = globalCommandManager;
